import React from "react"
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography} from "@mui/material"

function ConfirmationDialog({
	onCancel,
	onOK,
	isOpen,
	description,
}: {
	onCancel: () => void
	onOK: () => void
	isOpen: boolean
	description: string
}) {
	return (
		<Dialog sx={{"& .MuiDialog-paper": {width: "80%", maxHeight: "50%"}}} maxWidth="xs" open={isOpen}>
			<DialogTitle align="center">Confirmation</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body2" display="block">
					{description}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel}>Cancel</Button>
				<Button onClick={onOK}>Ok</Button>
			</DialogActions>
		</Dialog>
	)
}

export {ConfirmationDialog}
